// Importing countries
import { COUNTRIES_EN } from './countries';

export const LANG_EN_CODE = 'en-US';
export const LANG_EN_NAME = 'Eng';
export const LANG_EN_COMPLETE_NAME = 'English';
// ==== SUPPORTED LANGUAGES ====
// =============================
const LANG_EN = {
  'en-US': 'English',
  'es-ES': 'Español',
  'da-DA': 'Dansk',
  'fr-FR': 'Français',
  'fr-CA': 'Français (Canada)',
  'de-DE': 'Deutsch',
  'nl-NL': 'Nederlands',
  'ENGLISH': 'English',
  'SPANISH': 'Español',
  'DANISH': 'Dansk',
  'FRENCH': 'Français',
  'CANADIAN FRENCH': 'Français (Canada)',
  'GERMAN': 'Deutsch',
  'DUTCH': 'Nederlands',
  'MORE_INFO': 'More info',
  // =========== LOGIN ===========
  // =============================
  'HOME': {
    'TITLE': 'Group Knowledge is Power',
    'TEXT': 'Concept Systems Incorporated brings organizations working on any collaborative initiative superior processes for capturing group wisdom from different points of view.'
  },
  'AUTO_LOGOUT': {
    'WARNING': {
      'TITLE': 'Still there?',
      'BUTTON': 'Continue Working',
      'MESSAGE': 'For security, we\'ll log you out if you\'re still inactive after ',
      'SECONDS': 'seconds'
    }
  },
  'LOGIN': {
    'USERNAME': 'Username',
    'USERNAME_OR_EMAIL': 'USERNAME OR EMAIL',
    'OR': 'or',
    'ACTIVATE_ACCOUNT': 'Activate your account',
    'ACTIVATE_ACCOUNT_TEXT': 'Create an account and start contributing with important research projects while having fun!',
    'ASSIGNED_USERNAME': 'ASSIGNED USERNAME',
    'YOUR_USERNAME': 'YOUR USERNAME',
    'ANONYMOUS_ACCOUNT': 'Anonymous account',
    'DIFFERENT_EMAIL': 'I want to use a different email',
    'PASSWORD': 'PASSWORD',
    'FORGOT_PASSWORD': 'Forgot password?',
    'LOCKED_ACCOUNT': '*Your account has been locked. Please contact the Project support team',
    'INVALID_USER': 'Invalid username or password. Try again or contact the Project support team.',
    'WRONG_PASSWORD_1': 'Wrong password! You have 1 more try',
    'WRONG_PASSWORD': 'Wrong password! You have ',
    'MORE_TRIES': ' more tries!',
    'RESET_PASSWORD': 'Reset password',
    'DONE': 'DONE',
    'INVITE_PROMPT': 'You\'ve been invited to participate in a new project',
    'INVITE_PROCEED': 'Proceed to project',
    'HAVE_ACCOUNT': 'Already have an account?',
    'ASSIGNED_ACCOUNT': 'If you have an ASSIGNED username and password, ',
    'ASSIGNED_LINK': 'CLICK HERE',
    'LOGIN_HERE': 'Login here',
    'RESET_EXPIRE': 'Your reset password link has expired. Please request a new one below to reset your password',
    'RESEND': 'RESEND',
    'PWD_CONFIRMATION': 'New password confirmation',
    'PDW_CHANGE_SUCCESSFULLY': 'Your password has been changed successfully.',
    'CONTINUE': 'CONTINUE',
    'CREATE_PASSWORD': 'Create a password',
    'CREATE_ACCOUNT': 'Create an account',
    'CP_SUBTITLE': 'Set a password for your anonymous account',
    'CP_SUBTITLE_USERNAME': 'Set a password for your assigned username',
    'CP_SUBTITLE_EMAIL': 'Set a password for your email',
    'ANONYMOUS_SUGGESTION_TEXT': 'We strongly suggest to write this down.',
    'WHY': 'Why?',
    'CONFIRM_PASSWORD': 'CONFIRM PASSWORD',
    'LOG_IN': 'Log in',
    'FINISH_SU_ACCOUNT': 'Finish setting up your account',
    'EMAIL': 'EMAIL',
    'CHECK_INBOX': 'Check your inbox',
    'EMAIL_TEXT_NOTIFICATION': 'We’ve sent an email to',
    'EMAIL_TEXT_NOTIFICATION_2': 'with a link to activate your account.',
    'CLICK_LINK': 'Click on the link and you’re good to go!',
    'BACK_LOGIN': 'Back to login',
    'SEND_EMAIL_TEXT_NOTIFICATION': 'We will send you an email with instructions on how to reset your password to the following address:',
    'FP_EMAIL_TEXT_NOTIFICATION': 'An email is on its way! You should be getting instructions on how to reset your password soon, just make sure to check your spam (just in case).',
    'DIDNT_GET_EMAIL': 'Did not get the email?',
    'RESEND_LINK': 'Resend me the link',
    'RESET_PASSWORD_SUCCESS': 'Please contact your project team in order to reset your password.',
    'NO_ACTIVITIES': {
      'OOPS': 'Oops!',
      'TEXT_MAIN': 'It looks like this project has reached the necessary number of contributors.<br><br> You can ' +
      '<a href="mailto:support@conceptsystems.com">contact the project admin</a> if you have any questions!',
      'TEXT_NO_ACTIVITIES': 'No activities for this project invitation link are currently open.<br><br> You can contact the project admin if you have any questions!',
    },
    'INFO_REGISTER_IDENTIFIER': 'Project administrators will be able to send you an email through the system based on your participation status, but will not be able to see your email address to connect to your identifier.',
    'BROKEN_LINK': {
      'INFORMATION': 'Information:',
      'PROJECT_CONTACT': 'Project Contact:',
      'CAUSE': 'The link you used is broken - please review the original link and try again.',
      'TEXT': 'You can contact the project admin if you have any questions!',
    },
    'CERATE_ACCOUNT': 'CREATE ACCOUNT',
    'CREATE_ACCOUNT_IDENTIFIER': {
      'TITLE_CREATE': 'Create an account',
      'TITLE_START': 'and start contributing your ideas',
      'STUDENT_ID': 'STUDENT ID',
      'EMAIL': 'EMAIL',
      'EMAIL_INFO': 'Your email won\'t be visible to the project team',
      'CREATE_A_PASSWORD': 'CREATE A PASSWORD',
      'STRONG': 'Strong',
      'WEAK': 'Weak',
      'INVALID_USERNAME': 'Invalid username, try again',
      'INCOMPLETE_USERNAME': 'You must enter an username',
      'USERNAME': 'Username',
      'CHARACTERS_MINIMUM': 'Your password needs a minimum of 6 characters',
      'SAME_USERNAME': 'Your password is too similar to your username',
      'MISSING_DIGIT': 'Your password must have at least one number',
      'MISSING_UPPERCASE': 'Your password must have at least one uppercase character',
      'MISSING_LOWERCASE': 'Your password must have at least one lowercase character',
      'MISSING_SYMBOL': 'Your password must have at least one non-alphabetic character',
      'PASSWORD_MAX': 'You must enter a password',
      'PASSWORD_PLACEHOLDER': 'Enter your password',
      'SECURE_PASSWORD': 'A secure password should include at least:',
      'BASE_DIGIT': 'one number (0 through 9)',
      'UPPERCASE_CHARACTER': 'one uppercase character (a through z)',
      'LOWERCASE_CHARACTER': 'one lowercase character (a through z',
      'ALPHABETIC_CHARACTER': 'one non-alphabetic character (for example, !, $, %, #)',
      'MUST_PASSWORD_AGAIN': 'You must enter your password again',
      'PASSWORD_NOT_MATCH': 'Passwords don\'t match',
      'PASSWORD_AGAIN': 'Enter again your password',
    }
  },
  // ========= AUTOSAVE ==========
  // =============================
  'SAVING_STATUS': {
    'SAVED': 'All changes saved',
    'SAVING': 'Saving',
  },
  // ==== MY PROJECTS ===========
  // ============================
  'MY_PROJECTS': {
    'TITLE': 'My Projects',
    'TEXT': 'Click on a project to complete your assigned activities.',
    'NO_PROJECT': {
      'TITLE': 'Oops!',
      'TEXT': 'You are currently not assigned to any open project activities.',
    }
  },
  // ==== SYSTEM ERROR ===========
  // ============================
  'SYSTEM_ERROR': {
    'TITLE': 'Unexpected System error',
    'MESSAGE': {
      'TITLE': 'Oops!',
      'TEXT': 'An unexpected system error has occurred. Please try again in a few minutes. If the error continues, contact ',
      'EMAIL': 'support@conceptsystems.com',
    }
  },
  // ==== MY ACCOUNT ===========
  // ============================
  'MY_ACCOUNT': {
    'TITLE': 'My Account',
    'INFORMATION': 'Your Account Information',
    'USERNAME': 'Username',
    'EMAIL': 'Email',
    'PERSONAL_DETAILS': 'Personal Details',
    'FIRST_NAME': 'FIRST NAME',
    'EDIT': 'Edit',
    'SAVE': 'Save',
    'LAST_NAME': 'LAST NAME',
    'CHANGE_PASSWORD': 'Change Password',
    'DONT_SEND_EMAIL': 'Don\'t send me any GroupWisdom<sup>tm</sup> emails',
    'CURRENT_PASSWORD': 'Current password',
    'NEW_PASSWORD': 'New password',
    'CONFIRM_PASSWORD': 'Confirm password',
    'CHANGED': 'Changed:',
    'ANONYMOUS_ACCOUNT': 'Anonymous account',
    'TERMS': {
      'SHOW': 'Show',
      'LABEL': 'groupwisdom<sup>tm</sup> Term'
    },
    'PRIVACY': {
      'SHOW': 'Show',
      'LABEL': 'groupwisdom<sup>tm</sup> Privacy'
    },
    'ANONYMOUS_TOOLTIP': 'For anonymous accounts, your identity is not known by the project team.'
  },
  // ==== HEADER  =================
  // =============================
  'HEADER': {
    'MY_PROJECTS': 'Projects',
    'MY_ACCOUNT': 'Account',
    'NOTIFICATIONS': 'Notifications',
    'HELP_AND_SUPPORT': 'Help and Support',
    'ENABLE_ACCESSIBILITY_MODE': 'Enable Accessibility Mode',
    'DISABLE_ACCESSIBILITY_MODE': 'Disable Accessibility Mode',
    'SIGN_OUT': 'Sign Out',
    'CHOSE_LANGUAGE': 'Select language:'
  },
  // ==== FOOTER =================
  // =============================
  'FOOTER': {
    'ITEMS': {
      'PRIVACY': 'Privacy',
      'TERMS': 'Terms',
      'HELP': 'Help & Support'
    },
    'COPYRIGHT': 'Copyright © 2000-2023. All rights reserved. Powered by',
    'COPYRIGHT_STRING': 'Concept Systems, Inc'
  },
  // ==== NOTIFICATIONS =================
  // =============================
  'NOTIFICATIONS': {
    'TITLE' : 'NOTIFICATIONS',
    'TITLE_NO' : 'NO NEW NOTIFICATIONS',
    'TITLE_SINGLE' : 'ONE NEW NOTIFICATION',
    'TITLE_MULTIPLE' : 'NEW NOTIFICATIONS',
    'ALL': 'All notifications',
    'PAGER': {
      'SHOWING': 'SHOWING',
      'TO' : 'TO',
    },
    'NOTIFICATION': 'Notification',
    'FROM': 'From: ',
  },
  // ==== INFORMED CONSENT MODAL ===========
  // =======================================
  'INFORMED_CONSENT_MODAL': {
    'TITLE': 'Consent to Participate',
    'DOWNLOAD': 'Download consent form',
    'UPLOAD': 'Upload signed consent form',
    'TOOLTIP': 'Sign the consent form and upload it to continue to participate in the project.',
    'ACCEPT': 'ACCEPT',
    'DECLINE': 'DECLINE',
    'FILE_ERROR': {
      'TYPE': 'Consent to participate can only be uploaded in .pdf, .doc or .docx.',
      'SIZE': 'File limit is 10MB, try again.',
    },
    'NO_DATA': 'Consent to participate data has not been provided.'
  },
  // ==== THANK YOU MODAL ===========
  // =======================================
  'THANK_YOU_MODAL': {
    'BUTTON_LINK': 'NEXT'
  },
  // ==== DECLINE INFORMED CONSENT MODAL ========
  // ============================================
  'DECLINE_ICM': {
    'TITLE': 'You Declined',
    'TEXT': 'You are not able to proceed to the project activities without accepting the Consent to Participate.',
    'TEXT_1': 'Please contact the Project Team if you have any questions.',
    'CONTINUE': 'CONTINUE',
    'SING_OUT': 'Sign Out'
  },
  // ====== PROJECT ===========================
  // ==========================================
  'PROJECT': {
    'SHOW_PI': 'Show project info',
    'VIEW_IC': 'View Consent to Participate',
    'AVAILABLE_ACTIVITIES': 'YOUR AVAILABLE ACTIVITIES',
    'AVAILABLE_ACTIVITIES_TOOLTIP': 'Press or select any of the open, started, or completed activity boxes to enter and ' +
    'edit items in that activity. When an activity has not been entered before, it will show as open.  When an activity ' +
    'has been entered, until completed it will show as started.  Completed will appear when all the items in the activity' +
    ' have been finished or you have selected finished.',
    'PROJECT_INFO_MODAL': {
      'TITLE': 'Project contact information',
      'PHONE': 'Phone number:',
      'EMAIL': 'E-mail:',
      'NO_DATA': 'This project not have contact information'
    },
    'PREVIEW': {
      'EXIT_TITLE': 'You are previewing as a participant.',
      'EXIT_BUTTON': 'Exit preview'
    },
    'NO_ACTIVITIES': {
      'OOPS': 'Oops!',
      'TEXT_MAIN': 'It looks like this project has reached the necessary number of contributors. ' +
      'You can contact the project admin if you have any questions!',
      'TEXT': 'You have no activities assigned.'
    },
    'BRAINSTORMING': 'Brainstorming',
    'SORTING': 'Sorting',
    'RATING': 'Rating',
    'PQ': 'Participant Questions',
    'CLOSES': 'Closes'
  },
  // ==== BRAINSTORMING ========
  // ============================================
  'BRAINSTORMING': {
    'TITLE': 'Brainstorming',
    'INFO': 'Information',
    'INFORMATION': 'Think carefully about your ideas. You may add many of your thoughts and ideas from different areas and  experiences relating to the focus prompt.',
    'ADD_IDEAS': 'Add Ideas',
    'COLLECTED_STATEMENTS': 'Collected statements:',
    'COLLECTED_STATEMENTS_TOOLTIP': 'These are statements collected from all brainstorming participants.  The list refreshes each time you add a statement or press Refresh list.',
    'REFRESH': 'Refresh list',
    'FINISH': 'Finish',
    'STATEMENTS': {
      'ADD': 'Add Statement',
      'NEW_STATEMENT_PLACEHOLDER': 'Type to add an idea',
    },
    'ACTIONS': {
      'SEARCH': {
        'PLACEHOLDER': 'Search',
      }
    },
    'FOCUS_PROMPT': 'FOCUS PROMPT',
    'MOBILE_STATEMENTS': 'statements',
    'COLLECTED': 'collected',
    'FOCUS_PROMPT_TOOLTIP': 'This prompt is the focus statement of the project to help you generate ideas to create the content of the project. ' +
    'The statements will be used in the other project activities.',
    'HIDE_PROMPT': 'Hide Prompt',
    'DROPDOWN': {
      'SHOW_INTRODUCTION': 'Show introduction',
      'SHOW_TOUR_AGAIN': 'Show tour again',
      'LEAVE': 'Leave Brainstorming',
      'FINISH': 'Finish Brainstorming'
    },
    'MODAL': {
      'INTRODUCTION': {
        'BUTTON': 'START'
      },
      'LIMIT': {
        'TITLE': 'Brainstorming Limit',
        'DESCRIPTION': 'The project statement limit has been reached. You cannot add anymore.',
        'BUTTON': 'CLOSE'
      }
    },
    'PROJECT_HOME': 'Project Homepage',
    'RETURN': 'Return to',
    'THANK_YOU': {
      'TITLE': 'Thank you',
      'BUTTON': 'RETURN TO PROJECT HOMEPAGE',
      'BUTTON_LINK': 'NEXT'
    },
    'TEXTAREA': {
      'PLACEHOLDER': 'Type to add an idea'
    },
    'CHARACTERS_LEFT': 'characters left'
  },
  // === PARTICIPANT QUESTIONS ===
  // =============================
  'PARTICIPANT_QUESTIONS': {
    'TITLE': 'Participant Questions',
    'PAGE': 'Page',
    'OF': 'of',
    'FINISH': 'Finish',
    'BACK': 'Back',
    'NEXT': 'Next',
    'DECIMALS_ALLOWED': 'Up to %0 decimals allowed.',
    'RANGE': 'Min: %0 / Max: %1',
    'DROPDOWN': {
      'SHOW_INTRODUCTION': 'Show introduction',
      'LEAVE_QUESTIONS': 'Leave Questions',
      'FINISH_QUESTIONS': 'Finish Questions'
    },
    'TEXTAREA_PLACEHOLDER': 'Type response here',
    'SELECT': 'Select Option',
    'HOLD_MODAL': {
      'TITLE': 'Hold on',
      'DESCRIPTION': 'You need to complete all required questions to finish the activity.',
      'BUTTON': 'CONTINUE',
      'LEAVE_QUESTIONS_AND_RETURN_LATER': 'Leave Questions and return later'
    },
    'INTRODUCTION_MODAL': {
      'TITLE': 'Participant Questions',
      'BUTTON': 'START'
    },
    'PROJECT_HOME': 'Project Homepage',
    'RETURN': 'Return to',
    'THANK_YOU': {
      'TITLE': 'Thank you',
      'BUTTON': 'RETURN TO PROJECT HOMEPAGE',
      'BUTTON_LINK': 'NEXT'
    },
    'OOPS': {
      'TITLE': 'Oops!',
      'MESSAGE': 'There are no participant questions associated with this project.'
    },
    'OTHER': {
      'DEFAULT': 'Other',
      'PLACEHOLDER': 'Type answer here'
    },
    'CHARACTERS_LEFT': 'characters left',
    'ERRORS': {
      'NUMERIC': 'The question answer must be between the min and max values and cannot exceed the number of decimals indicated.'
    },
    'REQUIRED_FIELD': '* indicated required field'
  },
  // ====== RATING ===========================
  // ==========================================
  'RATING': {
    'RATING': 'RATING',
    'SHOW_INTRO': 'Show introduction',
    'LEAVE_QUESTION': 'Leave Questions',
    'FINISH_QUESTION': 'Finish Questions',
    'FOCUS_PROMPT': 'FOCUS PROMPT',
    'FINISH': 'Finish',
    'OF': 'of',
    'STATEMENTS': 'statements',
    'RATED': 'rated',
    'HIDE_PROMPT': 'Hide Prompt',
    'IMPORTANCE': 'IMPORTANCE',
    'CHOOSE_RATING': 'Choose your rating',
    'SELECT_RATING': 'SELECT RATING',
    'DECIMALS_ALLOWED': 'Up to 2 decimals allowed.',
    'MIN': 'Min',
    'MAX': 'Max',
    'MODAL': {
      'INTRODUCTION': {
        'BUTTON': 'START',
      },
      'FINISH': {
        'TITLE': 'Finish activity',
        'DESCRIPTION': 'The activity status is already finished',
        'ACTIONS': {
          'CONTINUE': 'CONTINUE',
          'LINK': 'Leave Sorting and return later'
        }
      }
    },
    'PROJECT_HOME': 'Project Homepage',
    'RETURN': 'Return to',
    'THANK_YOU': {
      'TITLE': 'Thank you',
      'BUTTON': 'RETURN TO PROJECT HOMEPAGE',
      'BUTTON_LINK': 'NEXT'
    },
    'STATEMENTS_LIST': {
      'PAGE': 'Page',
      'OF': 'of',
      'STATEMENTS': 'Statements',
      'TO': 'to',
      'ON': 'On',
      'ON_PAGE': 'On this page:',
      'ALL': 'All',
      'UNRATED': 'Unrated',
      'RATED': 'Rated',
      'BACK': 'BACK',
      'NEXT': 'NEXT'
    },
    'VALIDATION_ERROR': 'The rating must be between the min and max values',
    'UNRATE': 'unrate'
  },
  // ========== SORTING ==========
  // =============================
  'SORTING': {
    'TITLE': 'Sorting',
    'CARDS': {
      'TITLE': 'Cards',
      'MORE': 'more',
      'LESS': 'less',
      'ALL': 'All',
      'UNSORTED': 'Unsorted',
      'SORTED': 'Sorted',
      'PILES': 'Piles',
      'SORT_IN': 'sort in',
      'IN_PILE': 'in pile',
      'UNIQUE': 'card',
      'MULTIPLE': 'cards'
    },
    'INTRODUCTION': 'Drag and drop cards to create piles',
    'OF': 'of',
    'STATEMENTS': 'statements',
    'SORTED': 'sorted',
    'AUTO_SAVE': 'All changes saved',
    'FINISH': 'FINISH',
    'EXPAND_ALL': 'Expand All',
    'COLLAPSE_ALL': 'Collapse All',
    'DROPDOWN': {
      'SHOW_INTRODUCTION': 'Show introduction',
      'SHOW_TOUR_AGAIN': 'Show tour again',
      'LEAVE_SORTING': 'Leave Sorting',
      'FINISH_SORTING': 'Finish Sorting'
    },
    'MODAL': {
      'LANDSCAPE': {
        'MESSAGE': 'For an ideal experience, place your tablet on landscape mode'
      },
      'INTRODUCTION': {
        'BUTTON': 'START'
      },
      'DELETE_PILE': {
        'TITLE': 'Delete Pile',
        'DESCRIPTION': 'Are you sure you want to delete the selected pile?',
        'BUTTONS': {
          'CANCEL': 'CANCEL',
          'YES': 'YES'
        }
      },
      'FINISH': {
        'TITLE': 'Sorry',
        'DESCRIPTION': 'You need at least %0 cards sorted to be able to finish.',
        'ACTIONS': {
          'CONTINUE': 'CONTINUE',
          'LINK': 'Leave Sorting and return later'
        }
      },
      'SORT_IN': {
        'NEW_PILE': 'NEW PILE',
        'PLACEHOLDER': 'Type a name',
        'NO_PILES': 'No piles created yet',
        'SORT': 'SORT',
        'SEND': 'SEND',
        'CARD': 'CARD %0',
        'INTO': 'INTO...',
        'TO_PILE': 'TO PILE',
        'CREATE_NEW_PILE': '+ Create new pile',
        'SAVE_NEW_PILE': 'Save',
        'CANCEL': '< Back to statements',
        'SAVE': 'SAVE',
        'SUCCESS': 'Card sorted successfully',
        'NAMING': 'NAMING Piles IS IMPORTANT!',
        'ERROR_HELPER_PILE_NAME': 'You must name this pile.'
      },
      'PILE': {
        'TITLE': 'PILE',
        'VIEW': 'View cards in pile',
        'EDIT': 'Edit pile name',
        'DELETE': 'Delete pile',
        'CANCEL': '< Back to piles',
        'SAVE': 'SAVE',
        'CREATE': 'Create Pile'
      }
    },
    'FOCUS_PROMPT': {
      'TITLE': 'FOCUS PROMPT:',
      'SUB_TITLE': 'To build national wellness in our communities and for our people, we should...',
      'HIDE_PROMPT': 'Hide Prompt'
    },
    'DROP': {
      'CREATE': 'Drop to create',
      'NEW': 'new pile'
    },
    'DELETE_PILE': 'delete pile',
    'DROP_TO_CREATE': 'Drop to create',
    'NEW_PILE': 'new pile',
    'PILE_PLACEHOLDER': 'Type pile name',
    'PROJECT_HOME': 'Project Homepage',
    'RETURN': 'Return to',
    'THANK_YOU': {
      'TITLE': 'Thank you',
      'BUTTON': 'RETURN TO PROJECT HOMEPAGE',
      'BUTTON_LINK': 'NEXT'
    },
    'REVIEW': {
      'TITLE': 'Almost Done!',
      'UNNAMED': 'Unnamed piles',
      'ALL_NAMED': 'All piles have been named!',
      'ALL_NAMED_DESCRIPTION': 'Please select Done to finish activity',
      'REVIEW': 'to review',
      'DONE': 'Done',
      'FINISH': 'Finish without naming',
      'BACK': 'Back to sorting',
      'ACTIONS': {
        'OK': 'OK',
        'TRY_USING': 'Try using',
        'OR': 'or',
        'SWITCH': 'to switch piles'
      }
    },
    'PILES': {
      'NO_SORTED': 'No statements have been sorted into piles yet!'
    }
  },
  'HELP_SUPPORT': {
    'TITLE': 'Help & Support',
    'SUBTITLE': 'What do you need help with?',
    'CONTACT': {
      'TECHNICAL': 'Technical support:',
      'SEND_MESSAGE': 'Send us your message',
      'GET_BACK': 'We’ll get back to you as soon as we can!',
      'PROJECT': 'PROJECT',
      'EMAIL_PHONE': 'CONTACT EMAIL OR PHONE',
      'OPTIONAL': 'Optional',
      'TOPIC': 'TOPIC',
      'ADDITIONAL_INFO': 'ADDITIONAL Info',
      'LET_US': 'Let us know which activity you are having trouble with. Provide all the information possible',
      'SUCCESS': 'Your message has been successfully sent',
      'CONTACT_ERROR': 'Please check the email or phone typed.'
    },
    'MODAL': {
      'TITLE': 'Message cannot be sent',
      'TEXT': 'This project does not have a contact listed with us.',
      'CONTACT': 'You can contact technical support or email support@conceptsystems.com.',
      'OK': 'OK'
    },
    'MOST_FREQUENT': 'Most Frequent Questions',
    'PQ': 'Participant Questions',
    'BS': 'Brainstorming',
    'TST': 'Tabletop Sorting',
    'DST': 'Dropdown Sorting',
    'RT': 'Rating Questions',
    'CONTACT_US': 'Contact us',
    'FOR': 'for',
    'PLACEHOLDER': 'The Future Foundation'
  },
  'FIRST_LOGIN': {
    'LINKS': {
      'PRIVACY': 'Privacy',
      'TERMS': 'Terms'
    }
  },
  'FORMS': {
    'PASSWORD_REQUIREMENTS': {
      'TITLE': 'A secure password should include at least:',
    }
  },
  'LOCK': {
    'TITLE': 'Finish all required questions first',
    'MESSAGE': 'You need to complete all required questions to finish the activity. Or you can leave and come back later!'
  },
  'BUBBLE': {
    'SKIP_INTRO': 'Skip intro',
    'BACK': 'Back',
    'NEXT': 'Next',
    'DONE': 'Done'
  }
};

export const LANG_EN_TRANS = Object.assign(LANG_EN, COUNTRIES_EN);



// WEBPACK FOOTER //
// ./src/app/translation/i18n/lang-en.ts